<template>
  <div style="width: 100%;margin: auto">
    <prohead></prohead>
    <div class="banner" style="background: url('../../static/img/k_bg.jpg');position: relative">
       <div style="position: absolute;left: 42%">合作 成长 共赢+</div>
    </div>
    <div class="box5_banner" style="padding-top: 40px;background: #ffffff" >

      <div>
        <ul class="tab-title">
          <li v-for="(title,index) in tabTitle" @click="cur=title.cate_name" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
        </ul>
      </div>

    </div>
    <div style="background: #ffffff" v-show="cur == '合作资质'">
    <div class="banner_kai" id="">
      <div style="text-align: center">
        <div class="titlebox" style="padding-top: 65px">合作资质</div>
        <p class="title_fu">qualification</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>


      <div class="banner_pin" style="padding-top: 40px">
        <div style="color: #666666;margin-left: 90px;margin-bottom: 10px">诚邀有志者 共创新未来，为了双方的合作更加愉快有效，我们希望您：</div>
        <div class="boxtitel" style="width: 1290px;height: 570px;background: url('../../static/img/11.jpg')">
          <div style="    position: absolute;
    top: 253px;
    left: 118px;">看好新儿童乐园的发展前景，热爱儿童事业，并且具有吃苦耐劳的创业精神。</div>
          <div style="position: absolute;
    top: 387px;
    left: 272px;
    width: 133px;">认可“开心玩国”的企业文化和经营理念。</div>
          <div style="position: absolute;
    top: 226px;
    left: 434px;
">具有良好的合作精神，勤奋务实，遵纪守法，诚实守信。</div>
          <div style=" position: absolute;
    top: 255px;
    left: 636px;">具有一定的经营管理经验；有一定资金实力，自有物业或能租赁场地者优先。</div>
          <div style="position: absolute;
    top: 231px;
    left: 842px;">在当地有一定的社会关系基础。</div>
          <div style="position: absolute;
    left: 983px;
    top: 358px;">愿意接受总部统一管理，自觉维护“开心玩国”品牌形象。</div>
        </div>
      </div>
    </div>
    </div>
<!--    <div class="box6" id="fzlc" style="background: url('../../static/img/bg3.jpg');">-->
<!--      <div style="text-align: center">-->
<!--        <div class="titlebox" style="padding-top: 65px;color: #ffffff">合作政策</div>-->
<!--        <p class="title_fu" style="color: #ffffff">culture</p>-->
<!--        <img style="margin-top: 10px;" src="../../static/img/biaoti2.png" alt="">-->
<!--      </div>-->


<!--    </div>-->
    <div style="background: #ffffff;padding-bottom: 50px" id="" v-show="cur == '合作步骤'">
      <div style="text-align: center">
        <div class="titlebox" style="padding-top: 65px;">合作步骤</div>
        <p class="title_fu">culture</p>

        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>

      <div style="background: url('../../static/img/5555.jpg');height: 500px;
        display: flex;
    justify-content: center;
    text-align: center;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat">
          <div style="position: relative;left: -649px;">
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 80px;left: 55px">
              <p style="font-size: 30px;"><i>01</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">投资咨询</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 310px;left: 188px;">
              <p style="font-size: 30px;"><i>02</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">实地考察</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 85px;left: 327px">
              <p style="font-size: 30px;"><i>03</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">签定意向</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 315px;left: 466px;">
              <p style="font-size: 30px;"><i>04</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">分析报告</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 85px;left: 600px">
              <p style="font-size: 30px;"><i>05</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">正式签约</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 315px;left: 755px;">
              <p style="font-size: 30px;"><i>06</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">设计方案</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 85px;left: 875px">
              <p style="font-size: 30px;"><i>07</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">装修安装</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 315px;left: 1036px;">
              <p style="font-size: 30px;"><i>08</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">培训开业</p>
            </div>
            <div style="width: 100px;height: 100px;text-align: center;color: #ffffff;position: absolute;top: 85px;left: 1160px">
              <p style="font-size: 30px;"><i>09</i></p>
              <p style="font-size: 18px;font-weight: 500;line-height: 40px">售后服务</p>
            </div>
          </div>

      </div>
    </div>
    <div style="width: 100%;height: 1500px;background: #ffffff" id="" v-show="cur == '扶持政策'">
        <div style="width: 1300px;height: 600px;margin: 0 auto;position: relative">
          <div style="text-align: center;padding-top: 50px">
            <div class="titlebox" >承诺式创业投资经典项目</div>
            <p class="title_fu" style="padding-top: 10px">16大扶持 360°贯穿全程确保所有合作伙伴100%成功盈利</p>
            <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
          </div>
          <div style="margin-top:70px ">
            <div class="boxshow1">
              <img src="../../static/img/xs.png" alt="">
              <div class="bosshowtitle">创业分析</div>
              <div class="boxcontent">协助创业者进行市场调查、商圈分析、投资时效与回报率等专业分析。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/tzgh.png" alt="">
              <div class="bosshowtitle">投资规划</div>
              <div class="boxcontent">给予投资者可持续发展的、实际操作步骤与发展规划。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/xz.png" alt="">
              <div class="bosshowtitle">选址建议</div>
              <div class="boxcontent">派人深入当地，免费协助投资者选到当地最好的店面。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/zx.png" alt="">
              <div class="bosshowtitle">装修设计</div>
              <div class="boxcontent">总部帮助开店合伙人进行统一品牌形象的店铺装修设计。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/cp.png" alt="">
              <div class="bosshowtitle">产品支持</div>
              <div class="boxcontent">相关售卖产品总部直接配送到店，并辅助进行产品陈列工作。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/mfaz.png" alt="">
              <div class="bosshowtitle">免费安装</div>
              <div class="boxcontent">将全套设施运送到位，并派遣专业施工团队驻地免费安装，确保质量。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/wl.png" alt="">
              <div class="bosshowtitle">物料支持</div>
              <div class="boxcontent">免费提供视觉VI系统、海报POP等宣传物料及运营物料设计稿。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/xt.png" alt="">
              <div class="bosshowtitle">系统支持</div>
              <div class="boxcontent">ERP管理系统，涵盖市场、营销、会员、教学、管理及绩效奖励等等。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/zy.png" alt="">
              <div class="bosshowtitle">专员带店</div>
              <div class="boxcontent">经验丰富的督导专员，下店指导，手把手教开店管理与营销，直到获利。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/rc.png" alt="">
              <div class="bosshowtitle">人才输送</div>
              <div class="boxcontent">店长、销售、营销、早教老师、体能教练等专业人才，总部不定时输送。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/dxhd.png" alt="">
              <div class="bosshowtitle">大型活动</div>
              <div class="boxcontent">定期的大型夏令营、冬令营拓展活动，与合作伙伴共享经验与成果。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/zy.png" alt="">
              <div class="bosshowtitle">专业培训</div>
              <div class="boxcontent">“阶梯式理论培训+骨干带店实践+在线咨询”，立体培训，小白变高手。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/ggcy.png" alt="">
              <div class="bosshowtitle">广告策应</div>
              <div class="boxcontent">总部全年不间断的进行全网立体宣传，扩大品牌影响力。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/mffl.png" alt="">
              <div class="bosshowtitle">免费分流</div>
              <div class="boxcontent">对于总部通过各种渠道获得的消费客户，将免费分流给所在区域合作商。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/yxzd.png" alt="">
              <div class="bosshowtitle">营销指导</div>
              <div class="boxcontent">量身定制营销策划、节假日促销，协助加盟商解决运营中出现的问题。</div>
            </div>
            <div class="boxshow1">
              <img src="../../static/img/xz.png" alt="">
              <div class="bosshowtitle">店铺升级</div>
              <div class="boxcontent">设备定期维护升级，项目实时更新，让老店焕新持久赚、新店开店就爆。</div>
            </div>
          </div>
        </div>
    </div>
    <div style="text-align: center;background: white" id="" v-show="cur == '营销赋能'">

      <div class="titlebox" id="yxfn" style="padding-top: 65px;">赋能营销</div>
      <p style="margin-top: 10px;" class="title_fu">marketing</p>
      <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">

      <div style="width: 1300px;height: 600px;margin: 0 auto;margin-top: 30px">
          <div class="boxjoinus join1" >
              <div style="float: left;border-right: 1px solid #F3C87B;padding-right: 15px">
                <p style="font-size: 30px;color: #FFC000">情感</p>
                <p style="color: #FFC000">共鸣营销</p>
              </div>
            <div style="padding-top: 12px;
    padding-left: 15px;float: left;color: #EBAC3B;width: 480px;text-align: left">做儿童乐园，那是一份关于爱的事业，把每个细节的品质和服务做
              到位，打动家长与孩子。</div>
          </div>
          <div class="boxjoinus join2" style="">
            <div style="float: left;border-right: 1px solid #FFAA58;padding-right: 15px">
              <p style="font-size: 30px;color: #FFAA58">借势</p>
              <p style="color: #FFAA58">关联营销</p>
            </div>
            <div style="
    padding-left: 15px;float: left;color: #FFAA58;width: 480px;text-align: left;">学校、幼儿园跟儿童相关的所有产业都可以是你的战略合作伙伴，互
              通有无，共赢未来。定期开展一些活动；与区域范围内的儿童用品商家
              合作，实行广告互换等等。</div>
          </div>
          <div class="boxjoinus join3" style="">
            <div style="float: left;border-right: 1px solid #E88866;padding-right: 15px">
              <p style="font-size: 30px;color: #E88866">引流</p>
              <p style="color: #E88866">网络营销</p>
            </div>
            <div style="
    padding-left: 15px;float: left;color: #E88866;width: 480px;text-align: left">互联网是新兴的、最具快速传播力的广告平台。现在谁不上网？！所
              以利用微博、博客、社区、论坛等一切可以营销的手段进行立体轰炸，
              免费广告何乐而不为？</div>
          </div>
          <div class="boxjoinus join4" style="">
            <div style="float: left;border-right: 1px solid #DF584D;padding-right: 15px">
              <p style="font-size: 30px;color: #DF584D">黏性</p>
              <p style="color: #DF584D">会员营销</p>
            </div>
            <div style="
    padding-left: 15px;float: left;color: #DF584D;width: 480px;text-align: left">给每一位顾客建议档案，设置VIP会员制，通过积分、节假日促销、
              短信祝福问候、沙龙等活动，将老顾客抓牢，同时发展新顾客，客
              流源源不断，也就财源滚滚！</div>
          </div>
          <div class="boxjoinus join5" style="">
            <div style="float: left;border-right: 1px solid #26B0C0;padding-right: 15px">
              <p style="font-size: 30px;color: #26B0C0">口碑</p>
              <p style="color: #26B0C0">体验营销</p>
            </div>
            <div style="padding-top: 12px;
    padding-left: 15px;float: left;color: #26B0C0;width: 480px;text-align: left">可做一些免费试玩策略，吸引顾客进店；不定期发放免费体验卡等，
              吸引潜在消费者上门。</div>
          </div>
          <div class="boxjoinus join6" style="">
            <div style="float: left;border-right: 1px solid #386091;padding-right: 15px">
              <p style="font-size: 30px;color: #386091">人气</p>
              <p style="color: #386091">活动营销</p>
            </div>
            <div style="
    padding-left: 15px;float: left;color: #386091;width: 480px;text-align: left">节日、假日、纪念日，促销活动最好使。配上如探险比赛、儿童剧演
              出、亲子活动、成果汇报展等活动，既增加人流量，提高知名度，更
              让孩子们在开心玩国的平台上成为小明星！</div>
          </div>
          <div class="boxjoinus join7" style="">
            <div style="float: left;border-right: 1px solid #442F66;padding-right: 15px">
              <p style="font-size: 30px;color: #442F66">拓客</p>
              <p style="color: #442F66">工具营销</p>
            </div>
            <div style="
    padding-left: 15px;float: left;color: #442F66;width: 480px;text-align: left">超全的拓客系统，包括门店、小程序、抖音、朋友圈等，采用短视频、
              电子券、图文素材等方式，进行全网oto引流裂变，顾客找上门，生
              意不火都难。</div>
          </div>
      </div>
    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import {goAnchor,GetQueryString} from '../../static/js/common';
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
import Swiper from "swiper";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data () {
    return {
      cur: '合作资质',
      tabTitle:[{
        cate_name:'合作资质'
      },{
        cate_name:'合作步骤'
      },{
        cate_name:'扶持政策'
      },{
        cate_name:'营销赋能'
      }],
      activeIndex: '1',
      activeIndex2: '1',
      navLists:[
        {
          "text":"首页",
          "url":'/'
        },
        {
          "text":"开心玩国",
          "url":'/ProRecommend',
        },
        {
          "text":"创新产品",
          "url":'/ProRecommending',

        },
        {
          "text":"财富世界",
          "url":'/add'
        },
        {
          "text":"加入我们",
          "url":'/Joinus'
        },
        {
          "text":"新闻资讯",
          "url":'/newadd'
        },
        {
          "text":"联系方式",
          "url":'contactus'
        }
      ],
      changeRed:0,
      fullpath:''
    }
  },

  watch: {
    $route(to, from) {
      console.log('lalala', this.$route.query.id)
      if (this.$route.query.id == undefined) {
        this.cur = '合作资质'
      } else {
        if (this.$route.query.id) {
          console.log('12131231', this.$route.query.id)

          this.cur  = this.$route.query.id
          console.log('8888888888888888',this.cur)
        }
      }

    }
  },

  created() {
  },
  mounted() {
    new Swiper ('.swiper-container', {
      slidesPerView: 4,
      spaceBetween: 30,
      loop: true,
      // 如果需要分页器
      // 如果需要前进后退按钮
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      // autoplay: {
      //   delay: 1000,//时间 毫秒
      //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
      // },
    })
    this.$nextTick(() => {
      let maodian=this.GetQueryString('maodian');
      if(maodian){
        console.log('11111111111111111',maodian)
        this.goAnchor('#'+maodian);

      }
    });

  },
  methods:{
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问fetchData，将query参数name，传递过去，进行逻辑处理
        // debugger
        // console.log(to)
        // console.log(from)
        //       console.log(vm.$route); //有值
        //       next()
        if (from.fullPath === "****") {  //关键判断这里区别，自己刷新是 /
          vm.fullpath = from.fullPath;
          this.$router.go(0);
        }

        // vm.fetchData(vm.$route.query.name);
      });
    },
    goAnchor,

    GetQueryString,

  },
}
</script>

<style scoped>
.linear-link{
  position: absolute;
  bottom: 0;
  width: 252px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: #FFFFFF;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px !important;
  line-height: 50px;
}
.solution {
  margin-bottom: 10px;
}
.solution:hover{
  cursor: pointer;
}
.solution .media-img:hover  {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.box6_div:hover{
  background: rgb(234, 92, 72,0.5)
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img .mask {
  opacity: 0;
  z-index: 3;
  background: rgb(40 167 225 / 85%);
  width: 92%;
  height: 92%;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  transition: 0.3s;
  margin-left: 11px;
  margin-top: 12px;
}
.solution .media-img {
  position: relative;
//width: 252px;
//height: 300px;
}
.solution .media-img .mask .subtitle {
  padding: 17px;
  color: #ffffff;
  text-align: left;
}
.join1{
  background: rgba(243, 200, 123, 0.3);
}
.join1:hover{
  background: rgba(243, 200, 123, 0.5);
  cursor: pointer;
}
.join2{
  background: rgb(255, 170, 88,0.3)
}
.join2:hover{
  background: rgb(255, 170, 88,0.5);
  cursor: pointer;
}
.join3{
  background: rgb(232, 136, 102,0.3)
}
.join3:hover{
  background: rgb(232, 136, 102,0.5);
  cursor: pointer;
}
.join4{
  background: rgb(223, 88, 77,0.3)
}
.join4:hover{
  background: rgb(223, 88, 77,0.5);
  cursor: pointer;
}
.join5{
  background: rgb(38, 176, 192,0.3)
}
.join5:hover{
  background: rgb(38, 176, 192,0.5);
  cursor: pointer;
}
.join6{
  background: rgb(56, 96, 145,0.3)
}
.join6:hover{
  background: rgb(56, 96, 145,0.5);
  cursor: pointer;
}
.join7{
  background: rgb(68, 47, 102,0.3)
}
.join7:hover{
  background: rgb(68, 47, 102,0.5);
  cursor: pointer;
}
.boxjoinus{
  padding: 15px;
  width: 600px;
  height: 70px;
  float: left;
  margin-right: 14px;
  margin-bottom: 14px;
  //opacity: 0.3;
  border-radius: 10px;
}
.box6 {
  height: 600px;
  //background: url("../../static/img/bg3.jpg");
}
.boxtitel{
  position: relative;
}
.boxtitel div{
  float: left;
  width: 161px;
  height: 130px;
  margin-right: 3px;
  color: #ffffff;
  font-size: 18px;
  font-family: PingFang;
  font-weight: 500;
  line-height: 30px;
}
.banner_pin div{
  float: left;

}
.box3{
  margin: 0 auto;
  width: 100%;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.boxtitel div:hover{
  font-weight: 600;
  cursor: pointer;
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.tab-title{
  width: 1300px;
  height: 100px;
  margin: 0 auto
}
.tab-title li:hover{
  cursor: pointer;
}
.tab-title li{
  width: 180px;
  height: 60px;
  border-radius: 30px;
  float: left;
  border: 1px solid #C5C5C5;
  line-height: 60px;
  text-align: center;
  margin-right: 20px;
  font-size: 18px;
}
.tab-title .active{
  background: #EA5C48;
  color: white;
  cursor: pointer;
  border: 1px solid #EA5C48;

}
.boxshow1{
  width: 272px;
  height: 202px;
  border: 1px solid rgba(217, 217, 217, 0.2);
  border-radius: 4px;
  padding: 20px 14px 28px 14px;
  margin-right: 20px;
  margin-bottom: 20px;
  float: left;
}
.boxshow1:hover{
  cursor: pointer;
  background: #F6F6F6;
}
.boxshow1 img{
  text-align: center;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  display: block;
}
.bosshowtitle{
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 30px;
  text-align: center;
  margin-top: 26px;
}
.boxcontent{
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 16px;

}
</style>



// WEBPACK FOOTER //
// src/components/Joinus.vue